import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from "react-intl";
import { UiCard } from './ui';

class NeedAuth extends React.Component {

  state = { loggedIn: false };

  handleLogInClick() {
    const {identityProvider} = this.props;
    identityProvider.open();
  }

  afterLogIn() {
    const {identityProvider} = this.props;
    identityProvider.close();
    this.setState({ loggedIn: true });
  }

  componentDidMount() {
    const {identityProvider} = this.props;
    identityProvider.on("login", () => this.afterLogIn());
    identityProvider.on("logout", () => this.setState({ loggedIn: false }));
  }


  render() {
    const {children, identityProvider, showLoginButton = true} = this.props;
    const user = identityProvider.currentUser();
    if (!user) {
      return !!showLoginButton ? (
        <div className="tsk-login-wrap">
          <UiCard pad="lg" className="tsk-login-box">
            <p style={{ margin: 0, color: 'var(--tsk-fallback-muted, #94a3b8)', lineHeight: 1.5 }}>
              <FormattedMessage id={'unauthenticated.access.denied'} />
            </p>
            <div className={'tsk-bottom-buttons'}>
              <button type="button" className={'tsk-button'} onClick={() => this.handleLogInClick()}>
                <FormattedMessage id={'login.button'} />
              </button>
            </div>
          </UiCard>
        </div>
      ) : null;
    }
    user.jwt(); // Renew jwt token!

    return children
  }
}

NeedAuth.propTypes = {
  identityProvider: PropTypes.object.isRequired,
  showLoginButton: PropTypes.bool
};

export default NeedAuth
